import { menuFirsts } from "../../constants/menu"
import InheritanceTransfer from "../../pages/inheritanceTransfer/inheritanceTransfer"

const routeInheritanceTransfer = [
  {
    ...menuFirsts.INHERITANCE_TRANSFER,
    /** key ต้องตรงกับ menuFirstKey ที่ backend ส่งมา ไม่งั้น PrivateRoute หา activeMenu ไม่เจอ ปุ่มจะ disable หมด */
    key: menuFirsts.INHERITANCE_TRANSFER.key,
    name: menuFirsts.INHERITANCE_TRANSFER.name,
    textName: menuFirsts.INHERITANCE_TRANSFER.textName,
    active: false,
    appBar: true,
    component: InheritanceTransfer
  }
]

export default routeInheritanceTransfer
